import { useSuspenseQuery } from "@tanstack/react-query";
import api from "../../../api";

export const LAYOUT_DETAILS_KEY = "layoutDetails";

const getLayoutDetailsQueryKey = (id?: number | string, type?: string) => [
  LAYOUT_DETAILS_KEY,
  id,
  type
];

const getApi = (id?: string | number, type?: string) => {
  if (id === undefined || !type) return null;
  return api.getLayoutDetails(id, type).then(data => data.data);
};

const useGetLayoutDetails = (id?: number | string, type?: string) => {
  const { data, isPending, isSuccess, refetch } = useSuspenseQuery({
    queryKey: getLayoutDetailsQueryKey(id, type),
    queryFn: () => getApi(id, type)
  });

  return { data, isPending, isSuccess, refetch };
};

export default useGetLayoutDetails;
